// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-pro/css/all.css'
import Auth from '@/auth'
import currency from 'v-currency-field'
import vuemoment from 'vue-moment'

import 'v-currency-field/dist/index.css'

import axios from 'axios'

Vue.prototype.$http = axios.create({
  baseURL: process.env.API_URL + '/api/v1/'
})

Vue.use(currency)

Vue.use(vuemoment)

Vue.use(Vuetify, {
  theme: {
    primary: '#005881'
  },
  iconfont: 'fa'
})

Vue.use(Auth)

Vue.use(Vuex)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js